var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-detail-item flex"},[_c('label',{staticClass:"c-detail-item-label flex"},[(_vm.required)?_c('b',[_vm._v("*")]):_vm._e(),_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"c-detail-item-content flex-grow"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }